import React from 'react';
import { makeStyles, TableCell } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
	category: {
		background: '#FBE6E9',
	},
	head: {
		background: '#EEEEEE',
	},
}));

const CustomCell = React.forwardRef(({ type, className, children, ...rest }, ref) => {
	const classes = useStyles();

	return (
		<TableCell className={clsx(classes[type], className)} {...rest} ref={ref}>{children}</TableCell>
	);
});
CustomCell.displayName = 'CustomCell';

const CategoryCell = props => <CustomCell type="category" {...props} />;
const HeadCell = props => <CustomCell type="head" {...props} />;

export default CustomCell;
export { CategoryCell, HeadCell };